var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-modal',{attrs:{"active":_vm.active,"persist":true}},[_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('div',{staticClass:"text-center"},[_c('img',{attrs:{"src":"/static/img/loader.svg","alt":"Loader","width":"100"}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }